export const pages = {
  auth: {
    login: {
      title: 'Login'
    },
    confirmation: {
      title: 'Email confirmation',
      description:
        'We have sent a code to your email {email}. delivery may take up to one minute.'
    },
    verifyEmail: {
      title: 'Change password'
    },
    reset: {
      title: 'Change password'
    },
    otp: {
      title: 'Email confirmation',
      description:
        'We have sent a code to your email {email}. delivery may take up to one minute.'
    },
    register: {
      title: 'Register {role}'
    },
    invite: {
      title: 'Welcome to live bright connect',
      description: 'Choose your profile type'
    }
  },
  notification: {
    title: 'Notifications',
    notFound: 'You have no notifications yet.',
    description:
      'You can view new artist requests in the “artists” section of your profile.'
  },
  loyalty: {
    inputLabel: 'Your link:',
    registered: 'Registered',
    inputDescription: 'To invite an artist, send them this registration link.',
    artist: {
      title: 'Site invitation',
      description:
        'An invited artist is one who completed registration using your link.'
    },
    club: {
      title: 'Loyalty program',
      note: 'An invited artist is one who completed registration using your link.',
      description: 'Get artists without commission!',
      content:
        'When an artist registers through your link, they’re credited to you.📌 For every 5 artists, you receive 1 commission-free contract (valid for 1 calendar month). Even if the artist chooses another club, they will still count toward your total. ‼️ To participate in the program, your club must complete its profile and be visible in search. ⚡ Share your link, help the platform grow—and start benefiting right away.',
      text: "👯‍♀️ You had a casting and the artist didn't fit? Someone is finishing a contract? Send her your personal link."
    }
  },
  language: {
    title: 'Languages',
    description: 'Select platform language',
    options: {
      ru: 'Russian',
      en: 'English'
    }
  },
  profilePage: {
    techSupport: 'Care Service',
    privacy: 'Terms and Privacy',
    artist: {
      work: 'Club work',
      infoEditSection: 'Editing',
      infoAppSection: 'Application',
      personalInfo: 'Personal information',
      portfolio: 'Portfolio',
      invitationAndRequests: 'Requests & invitations',
      hideProfile: 'Hide profile',
      loyaltyLink: 'Invite a friend'
    },
    club: {
      clubInfoSection: 'Club information',
      artistsSection: 'Artists',
      artistHiring: 'Artist recruitment',
      loyaltyProgram: 'Loyalty program',
      editingSection: 'Editing',
      clubInfo: 'Club information',
      conditions: 'Conditions',
      approvedArtists: 'Approved artists',
      requestsAndInvitations: 'Requests & invitations',
      applicationSection: 'Application'
    }
  },
  portfolioPage: {
    title: 'Portfolio',
    warnNotPublished: 'Resume not published. fill portfolio to publish resume.',
    warnfillPortfolio: 'Fill portfolio',
    warnf: 'Fill portfolio',
    warnFillSection: 'Fill this section to increase invitation chances.'
  },
  profileInfo: {
    club: {
      title: 'Club information'
    },
    artist: {
      title: 'Personal information'
    }
  },
  clubTerms: {
    title: 'Terms',
    description:
      'Try to complete all steps fully. this affects listing attractiveness to artists. contact support if you encounter difficulties.',
    progressSteps: {
      schedule: 'Club work schedule',
      contractTerms:
        'Minimum contract term, artist schedule, tickets, airport transfer',
      payments:
        'Payments: rate, guarantee, full, topless, go-go, deposit, show, tea, consumption, crazy menu',
      workConditions:
        'Consumption type. Choreographer. Photoshoots. Poles. Quantity',
      housing: 'Accommodation information. Photos.',
      penalties: 'Penalty grid',
      photo: 'Club photos',
      video: 'Club videos'
    }
  },
  clubEmployers: {
    title: 'Approved artists',
    tabs: {
      pending: 'Pending',
      onContract: 'On contract'
    }
  },
  requestAndInvitation: {
    title: 'Requests & invitations'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Club working hours',
        popups: {
          title: 'Working hours'
        },
        changeAllWorkTimes: 'Change all working hours'
      },
      contractTerms: {
        title: 'Club working conditions',
        form: {
          minimalContractTerm: {
            label: 'Minimum contract term',
            unit: 'Weeks'
          },
          artistsSchedule: {
            label: 'Artist work schedule'
          }
        }
      },
      payments: {
        title: 'Payments',
        rateFieldDescription:
          'If you have a flat rate, fill in only one of the input fields.'
      },
      workConditions: {
        title: 'Club working conditions',
        form: {
          noExperienceEmployment: 'Employment of artists without experience',
          additionalInfo: {
            label: 'Additional club information',
            placeholder:
              'You can write about promotions or bonuses at your club or any other info that might interest artists',
            description: 'Enter at least 100 characters'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: 'Enter a dress code item',
            description:
              'Select a dress code for artists in your club. add missing items.'
          }
        }
      },
      housing: {
        title: 'Accommodation information'
      },
      penalties: {
        title: 'Penalties',
        description: 'Add your own items if not found in the provided list'
      },
      photo: {
        title: 'Club photos',
        description: 'Upload club photos. you can make changes later',
        options: {
          hallNoGuests: 'Empty hall photo',
          hallWithGuests: 'Hall with guests photo',
          privateRooms: 'Private rooms photo',
          scene: 'Stage photo'
        }
      },
      video: {
        title: 'Club videos',
        description: 'Upload club videos. you can make changes later',
        options: {
          ClubTour: 'Empty hall video',
          EventVideo: 'Hall with guests video',
          WorkingHours: 'Stage video'
        }
      }
    },
    artist: {
      work: {
        title: 'Club experience',
        addWorkPlace: 'Add work place',
        notHaveWorkExperience: 'Continue withouth experience'
      },
      language: {
        title: 'Languages',
        languageProficiency: 'Foreign language proficiency'
      },
      parametres: {
        title: 'Parameters'
      },
      about: {
        title: 'About me',
        description: 'Write something about yourself that would interest clubs',
        textAreaDescription: 'Enter at least 100 characters',
        textAreaPlaceholder: 'Enter'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy: 'Upload a runway video',
        videoForGogoVacancy:
          'Upload a dance video for strip and go-go vacancies'
      },
      photo: {
        title: 'Photo',
        description:
          'Upload photos. photos must be without filters or retouching.',
        FaceNoMakeup: 'Model – face without makeup.',
        FaceWithMakeup: 'Face / makeup.',
        FreePose: 'Model photo in a free pose.',
        FullBodyOnHeels: 'Full-length photo on heels.',
        LingerieOrSwimsuit: 'Swimsuit or lingerie photo',
        selectMainPhoto: 'Select main photo'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'Artist already works at the club',
      incompleted: 'To send invitations, you must complete your profile 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'You can request an end date for your contract and the club will send you your last working day date.',
      clubSetLastWorkDate: 'The club has set your last working day date.',
      clubNotHiring:
        'You cannot send a request because the club is not hiring.',
      pendingRequest: 'You cannot send more than one request within 48 hours.',
      haveContract:
        'You cannot send a request because you have an active contract.',
      hidden:
        'You cannot send a request because your profile is hidden from search.',
      incompleted:
        'You cannot send a request because you have not completed your profile.'
    }
  },
  notFoundWorkItem: {
    title: 'This invitation or request no longer exists.',
    description:
      'We’re sorry, but the page does not exist. please return to the homepage.'
  },
  notFoundCurrentWork: {
    title: 'No active contract',
    description:
      'You currently have no active contract, go to the search page and submit a request to start one.'
  },
  clubFullProfile: {
    clubVideo: 'Club video',
    clubPhoto: 'Club photo',
    clubHousingPhoto: 'Housing photo',
    minimalContractDuration: 'Minimum contract',
    artistWorkSchedule: 'Artist schedule',
    paymentFrequescyMessage: 'Artist consumption payouts — once'
  },
  privacyPolicy: {
    title: 'Terms of Service and Privacy Policy'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Invite manager to chat',
      managerIsInChat: 'Manager is in chat',
      manageRequestPending: 'Manager will join soon'
    },
    admin: {
      assistanceProvided: 'Assistance provided'
    }
  }
};
